import API_BASE_URL from "../utils/config";
import request from "../utils/request";


export async function fetchAllDepartments(data) {
  const url = `${API_BASE_URL}/departments`;
  return request({
    url,
    method: "get",
    data,
  });
}
export async function httpCreateDepartment(data) {
    const url = `${API_BASE_URL}/departments`;
    return request({
      url,
      method: "post",
      data,
    });
  }
export async function httpEditDepartment(data) {
    const { id, ...editData } = data;
    const url = `${API_BASE_URL}/departments/${id}`;
    return request({
      url,
      method: "patch",
      data: editData,
    });
  }
  export async function httpDeleteDepartment(id) {
    const url = `${API_BASE_URL}/departments/${id}`;
    return request({
      url,
      method: "delete",
    });
  }
  